<template>
  <div class="wrap">
    <div class="head">
      <img class="banner" src="./img/list/banner.png">
      <div class="text">
        <h2>大救星救援服务清单</h2>
        <p>全球范围专业救援服务</p>
      </div>  
    </div> 
    <div class="one">
      <div class="list"   style="position: relative;">
            <div style="width:50px;height:80px;position: absolute;z-index: 1;top: 160px;left: 1vw;margin-top:-40px" @click="Button('left')">
               <img src="./img/list/right.png" alt="">
            </div>
            <div style="width:50px;height:80px;position: absolute;top: 160px;z-index: 1;right:1vw;margin-top:-40px" @click="Button('right')">
               <img src="./img/list/left.png" alt="">
            </div>
          
        
        <ul class="ul" id="ID" style="display: -webkit-box;overflow: hidden;"> 
            <li :class="{ 'selection': isActive==index,'green': index==1||index==2,'daygreen': index==3,'yellow': index==4}" v-for="(item,index) in data.list" :key="index" @click="choice(index,item)">
            <h3>{{item.name}}</br><span v-if="item.name1" style="font-size: 1vw;font-weight: bold;color: rgba(51,51,51,1);letter-spacing: 2px;">{{item.name1}}</span></h3>
           
            <p>{{item.text}}</p>
            <p class="spacing">{{item.content}}</p>
            <span><strong>{{item.money}}</strong>元<i v-if="item.id==1||item.id==3 ||item.id==5 ||item.id==6">起</i></span>
          </li>
             
         
        </ul>
        <div :class="{'border': dataId,'borderGreen':dataId==2||dataId==3,'violet':dataId==5,'DayGreen':dataId==6,'yibottom':dataId==7}"></div>
        <ul class="type" style="overflow: hidden;" v-if="styleList.list">
          <li v-for="(list,index) in styleList.list" :key="index" @click="choiceType(index,list)">
            <p :class="{'selection': isActiveType==index,'green': dataId==2||dataId==3,'viselection':dataId==5,'yellow':dataId==6}" v-if="list.name">{{list.name}}</p>
          </li>
        </ul>
      </div>
    </div>

    
    <div :class="{'two':dataId ,'twoGreen':dataId==2||dataId==3}">
      <div class="topList">
        <div class="top">
          <div class="left">
            <!-- <h3>{{detailList.name}}</h3> -->
            <h3>{{detailList.name}}<span style="color:#f77730;float: right;margin-right: 1.2vw;"><strong v-if="dataId == 1"  style="color:#f77730;"><span style="font-size: 17px;">费用价格：</span>{{money}}</strong><strong v-else style="color:#f77730;"><span style="font-size: 17px;">费用价格：</span>{{detailList.money}}</strong>元</span></h3>
            <p v-if="detailList.list" v-for="(item,index) in detailList.list" :key="index">{{item}}</p>
            <div v-if="detailList.time && dataId != 6" class="time">
              选择保障时长：
              <span>
                <em :class="{'click':dateActive==index,'click1':dataId==5}" v-for="(item,index) in detailList.time" @click="choiceTime(index,item.id)">{{item.name}}</em>
              </span>
            </div>
            <div v-if="detailList.time && dataId == 6" class="time">
              选择保障时长：
              <span style="position: absolute;top: 0;left: 0;height: 2vw;">
                选择保障时长：自用户持门票和本清单凭证进入参观场所或游（娱）乐场所时起至离开该场所 界定的范围时止
              </span>
            </div>
             <div v-if="dataId == 7" class="time">
              <!-- 选择保障时长： -->
              <span style="position: absolute;top: 0;left: 0;height: 2vw;">
               救援范围：中国境外（含港澳台)
              </span>
            </div>
             <div v-if="dataId == 7" class="time">
              <!-- 选择保障时长： -->
              <span style="position: absolute;top: 0;left: 0;height: 2vw;">
              保障时长：1年（含等待期30天）
              </span>
            </div>
            
            <div v-if="detailList.type" class="time">
              选择类型：
              <span v-if="dataId==5">
                <em  :class="{'click1':typeActive==index}" v-for="(item,index) in detailList.type" @click="choiceTypeMoney(index,item)">{{item.name}}</em>
              </span>
              <span v-else-if="dataId==6">
                <em  :class="{'click2':typeActive==index}" v-for="(item,index) in detailList.type" @click="choiceTypeMoney(index,item)">{{item.name}}</em>
              </span>
              <span v-else-if="dataId==7">
                <em  :class="{'click3':typeActive==index}" v-for="(item,index) in detailList.type" @click="choiceTypeMoney(index,item)">{{item.name}}</em>
              </span>
              <span v-else>
                  <em :class="{'click':typeActive==index}" v-for="(item,index) in detailList.type" @click="choiceTypeMoney(index,item)">{{item.name}}</em>
              </span>
            </div>
          </div>
          <!-- 暂时隐藏，备案成功后放开 -->
          <!-- <div class="right">
            <h3>费用价格：<span><strong v-if="dataId == 1">{{money}}</strong><strong v-else>{{detailList.money}}</strong>元</span></h3>
            <vue-qr class='fukuanBox' :logoSrc="imagePath" :text="payImg" :size="500"></vue-qr>
            <p>微信扫码，可手机查看并购买</p>
          </div> -->
          <div class="right">
            <!-- <h3>费用价格：<span><strong v-if="dataId == 1">{{money}}</strong><strong v-else>{{detailList.money}}</strong>元</span></h3> -->
            <!-- <vue-qr class='fukuanBox' :logoSrc="imagePath" :text="payImg" :size="500"></vue-qr> -->
            <img src="./img/list/wxgzh_head.jpg" alt="">
            <p>扫码关注公众号，了解更多</p>
          </div>
        </div>
      </div>
      <div class="bottomList">
        <div class="bottom">
          <h3>{{service.name}}</h3>
          <h5>{{service.text}}</h5>
          <div class="give" v-if="service.give">
            <img src="./img/list/icon.png">
            <div>
              <h4>{{service.give.tit}}</h4>
              <p>{{service.give.text}}</p>
            </div>
          </div>
           

          <ul class="service" v-if="service.list && dataId !=5 && dataId !=6 && dataId !=7">
            <li v-for="(item,index) in service.list" :key="index">
              <img v-if="dataId==3 && listId==3" :src='"./img/list/service-video-" + item.id + ".png"'>
              <img v-else-if="dataId==1||dataId==4" :src='"./img/list/service-" + item.id + ".png"'>
             
              <img v-else :src='"./img/list/service-green-" + item.id + ".png"'>
              <p>{{item.name}}</p>
            </li>
          </ul>
           <div v-else>
            <ul class="service" style="display: -webkit-inline-box;margin-bottom: 0vw;">
                <li v-for="(item,index) in service.list.slice(0,6)" :key="index">
                    <img v-if="dataId ==5" :src='"./img/list/epidemic-" + item.id + ".png"'>
                    <img v-else-if="dataId ==6" :src='"./img/list/day-" + item.id + ".png"'>
                     <img v-else-if="dataId ==7" :src='"./img/list/labourservices-" + item.id + ".png"'>
                  <p :class="{'dayclass':dataId==6,'labclass':dataId==7}">{{item.name}}</p>
                </li>
            </ul>
            <ul class="service" style="display: -webkit-inline-box;float: left;">
                <li v-for="(item,index) in service.list.slice(6)" :key="index">
                    <img  v-if="dataId ==5"  :src='"./img/list/epidemic-" + item.id + ".png"'>
                    <img v-else-if="dataId ==6" :src='"./img/list/day-" + item.id + ".png"'>
                     <img v-else-if="dataId ==7" :src='"./img/list/labourservices-" + item.id + ".png"'>
                  <p :class="{'dayclass':dataId==6,'labclass':dataId==7}">{{item.name}}</p>
                </li>
            </ul>
           </div>
           
          <h3 style="clear: both">{{housekeeper.name}}</h3>
          <h5>{{housekeeper.text}} </h5>
           <div :class="{'serviceList1':dataId==5,'serviceList2':dataId==6,'serviceList3':dataId==7}" class="" v-if="housekeeper.list && dataId==5 || dataId==6 || dataId==7">
            <ul v-for="(item,index) in housekeeper.list" :key="index">
              <li v-for="(list,index) in item.list"  :key="index">
                <h6>{{list.tit}}</h6>
                <p>{{list.text}}</p>
              </li>
            </ul> 
          </div>
          <div class="serviceList" v-else-if="housekeeper.list && dataId != 5 && dataId != 6">
            <ul v-for="(item,index) in housekeeper.list" :key="index">
              <li v-for="(list,index) in item.list"  :key="index">
                <h6>{{list.tit}}</h6>
                <p>{{list.text}}</p>
              </li>
            </ul> 
          </div>
          <div v-if="giftRights">
              <h3 v-if="giftRights">{{giftRights.name}}</h3>
          <table v-if="giftRights && dataId == 1 && listId == 1 " class="form">
            <tr class="th">
              <td width="180">{{giftRights.table.th.type}}</td>
              <td width="140">{{giftRights.table.th.oneA}}</td>
              <td width="140">{{giftRights.table.th.oneB}}</td>
              <td width="140">{{giftRights.table.th.twoA}}</td>
              <td width="140">{{giftRights.table.th.twoB}}</td>
              <td width="140">{{giftRights.table.th.threeA}}</td>
              <td width="150">{{giftRights.table.th.threeB}}</td>
            </tr>
            <tr class="tr" v-for="(item,index) in giftRights.table.tr">
              <td style="padding: 0.3vw">
                <p>{{item.name}}</p>
                <span v-if="item.introduce">{{item.introduce}}</span>
              </td>
              <td>{{item.oneA}}</td>
              <td>{{item.oneB}}</td>
              <td>{{item.twoA}}</td>
              <td>{{item.twoB}}</td>
              <td>{{item.threeA}}<i v-if="item.tag">{{item.tag}}</i></td>
              <td>{{item.threeB}}</td>
            </tr>
          </table>
          <table v-else-if="giftRights && dataId == 1 && listId == 2 || dataId == 5 && listId == 1 || listId == 2 || dataId == 6 && listId == 1 || listId == 2" :class="{'form':dataId!=5 && dataId!=6,'form1':dataId==5,'form2':dataId==6}">
            <tr class="th">
              <td width="280">{{giftRights.table.th.type}}</td>
              <td width="240">{{giftRights.table.th.oneA}}</td>
              <td width="240">{{giftRights.table.th.oneB}}</td>
            </tr>
            <tr class="tr" v-for="(item,index) in giftRights.table.tr">
              <td style="padding: 0.3vw">
                <p>{{item.name}}</p>
                <span v-if="item.introduce">{{item.introduce}}</span>
              </td>
              <td>{{item.oneA}}</td>
              <td>{{item.oneB}}</td>
            </tr>
            
          </table>

          <table v-else-if="giftRights && dataId == 1 && listId == 2 || dataId == 7 " :class="{'form3':dataId==7}">
            <tr class="th">
              <td width="280">{{giftRights.table.th.type}}</td>
              <td width="240">{{giftRights.table.th.oneA}}</td>
            </tr>
            <tr class="tr" v-for="(item,index) in giftRights.table.tr">
              <td style="padding: 0.3vw">
                <p>{{item.name}}</p>
                <span v-if="item.introduce">{{item.introduce}}</span>
              </td>
              <td>{{item.oneA}}</td>
            </tr>
            
          </table>
          <span v-if="giftRights && dataId == 1 && listId == 1 || dataId != 5 && dataId != 6 && dataId != 7" class="tips">*不含突发性疾病医疗</span>
          </div>
          
           
         <div v-if="dataId == 5 || dataId == 6 || dataId == 7">
              <div class="introduce">
                <div @click="todetail" >
                  <div class="btn" :class="{'epidemic': dataId == 5,'Oneday':dataId == 6,'labour':dataId == 7}" >服务详情</div>
                </div>
              </div>
           </div>
        </div>
      </div>
      <div class="introduceList" v-if="dataId != 5 && dataId != 6  && dataId != 7">
        <div class="introduce">
          <ul class="housekeeper" v-if="serviceList" v-for="(item,index) in serviceList">
            <li class="title">
              <img v-if="dataId==1 || dataId==4 || dataId==5 || dataId==6 || dataId==7" :src='"./img/list/introduce-" + (index+1) + ".png"'>
              <img v-else :src='"./img/list/introduce-green-" + (index+1) + ".png"'>
              <h3>{{item.name}}</h3>
            </li>
            <li>
              <p>
                <span v-if="item.list.one" v-for="(list,index) in item.list.one">{{list}}</span>
                <span v-if="item.list.two" v-for="(list,index) in item.list.two">{{list}}</span>
                <span v-if="item.list.three" v-for="(list,index) in item.list.three">{{list}}</span>
              </p>
            </li>
          </ul>
          <!-- <ul v-if="serviceList">
            <li v-for="(item,index) in serviceList" :class="{'housekeeper':item.list.two,'housekeeperthree':item.list.three}">
              <h3>{{item.name}}</h3>
              <p v-if="item.list.one"><span v-for="(list,index) in item.list.one">{{list}}</span></p>
              <p v-if="item.list.two"><span v-for="(list,index) in item.list.two">{{list}}</span></p>
              <p v-if="item.list.three"><span v-for="(list,index) in item.list.three">{{list}}</span></p>
            </li>
          </ul> -->
          <div @click="todetail">
            <div class="btn">服务详情</div>
          </div>
        </div>
      </div>
      <div class="background"></div>    
    </div>
    <div class="one">
      <div :class="{'worry': dataId,'worryGreen':dataId==2||dataId==3,'worrypurple':dataId== 5,'worryday':dataId== 6,'servicesclass':dataId== 7}">
        <h2 v-if="dataId==5 || dataId==6 || dataId==7"><span>—</span>赴华中转期间的困扰<span>—</span></h2>
        <h2 v-else><span>—</span>旅行中的困扰<span>—</span></h2>
        <img v-if="dataId==1||dataId==4" class="bg" src="./img/list/bg.png">
         <img v-else-if="dataId==5" class="bg" src="./img/list/frameVI.png">
         <img v-else-if="dataId==6" class="bg" src="./img/list/frametour.png">
         <img v-else-if="dataId==7" class="bg" src="./img/list/labourkuang.png">
        <img v-else class="bg" src="./img/list/bg-green.png">
        <ul>
          <li v-for="(worry,index) in worryList.list" :key="index">
            <p class="date">{{worry.date}}</p>
            <img v-if="dataId==2" :src='"./img/list/overseas-" + worry.id + ".png"'>
            <img v-else-if="dataId==4" :src='"./img/list/labour-" + worry.id + ".png"'>
            <img v-else-if="dataId==5" :src='"./img/list/Rejuvenation-" + worry.id + ".png"'>
            <img v-else-if="dataId==6" :src='"./img/list/tourimg-" + worry.id + ".png"'>
             <img v-else-if="dataId==7" :src='"./img/list/services-" + worry.id + ".png"'>
            <img v-else :src='"./img/list/worry-" + worry.id + ".png"'>
            <h3>{{worry.tit}}</h3>
            <p class="text">{{worry.text}} </p>
          </li>
        </ul>
      </div>
      <div class="person" :class="{'person':dataId ,'personGreen': dataId==3 && listId!=2}" v-if="dataId!=5 && dataId!=6 && dataId!=7">
        <div class="highlights">
          <h2><span>—</span>产品亮点<span>—</span></h2>
          <div class="bright" v-for="(highlights,index) in style.bright" :key="index">
            <img v-if="dataId==1||dataId==4" :src='"./img/list/highlights-" + highlights.id + ".png"'>
            <img v-else :src='"./img/list/highlights-green-" + highlights.id + ".png"'>
            <div>
              <h3 :class="{'highGreen':dataId==2||dataId==3}" v-for="(hightext,index) in highlights.list" :key="index">{{hightext.tit}}<p v-if="hightext.text">{{hightext.text}}</p></h3>
            </div>
          </div>
          <!-- <ul>
            <li v-for="(highlights,index) in style.bright" :key="index">
              <img v-if="dataId==1||dataId==4" :src='"./img/list/highlights-" + highlights.id + ".png"'>
              <img v-else :src='"./img/list/highlights-green-" + highlights.id + ".png"'>
              <div>
                <h3 :class="{'highGreen':dataId==2||dataId==3}" v-for="(hightext,index) in highlights.list" :key="index">{{hightext.tit}}<p v-if="hightext.text">{{hightext.text}}</p></h3>
              </div>
            </li>
          </ul> -->
        </div>
        <div class="highlights guarantee" v-if="personList">
          <h2><span>—</span>保障人群<span>—</span></h2>
          <ul :class="{'guaranteeGreen':dataId==2||dataId==3}">
            <li v-for="(item,index) in personList" :key="index">
              <img :src='"./img/list/person-"+ item.id +".png"'>
              <p>{{item.name}}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <careful ref="children" :id="dataId"></careful>
    <div id="cover" v-if="cover"></div>

     <div class="Popupclass" v-if="cover">
            <div class="close">
              <span style="color:#FEFEFE;font-size: 25px;float: left;">企业购买对公转账信息</span>
                <img style="width: 15px;height: 15px;" src="./img/list/Icon1.png" alt="" @click="closeclick"/>
            </div>
            <div class="Bulletframe">
               <div class="textcals">企业可通过对公转账的方式为员工购买此项服务</div>
            </div>
            <div style="color:#333333;padding-left: 50px; margin-top: 15px;"><div style="width: 10px;height: 10px;display: inline-block;background-color: #00ABFA;border-radius: 10px;"></div><b style="margin-left: 15px;">对公转账信息</b></div>
            <div style="padding: 10px 50px;height:25px;color:#666666" v-for="(item,index) in list" :key="index"> {{ item.text }} </div>
            <div style="height: 20px;border-bottom: 1px solid rgba(238,238,238,1);width: 91%;margin: 0 auto;"></div>
          
            <div style="color:#333333;padding-left: 50px; margin-top: 10px;"><div style="width: 10px;height: 10px;display: inline-block;background-color: #00ABFA;border-radius: 10px;"></div><b style="margin-left: 15px;">购买及咨询请联系</b></div>
            <div style="padding: 10px 50px;height:25px;color:#666666" v-for="(item,index) in list1" :key="index"> {{ item.text }} </div>
            
     </div>
  </div>
</template>
<script>
import util from '@/util/util.js'
import careful from '@/views/rescuelist/careful.vue'
import list from "@/views/rescuelist/js/list.js"
import style from "@/views/rescuelist/js/style.js"
import detail from "@/views/rescuelist/js/detail.js"
import vueQr from 'vue-qr'
export default{
  components: {
    careful:careful,
    vueQr: vueQr
  },
  data(){
    return {
      list:[
        {text:'户名：江泰救援服务有限公司'},
        {text:'账号（人民币）：110921622710301'},
        {text:'开户行：招商银行股份有限公司北京西客站支行'},
        {text:'开户行地址：北京市丰台区广安路9号国投财富广场一层 '},
        {text:'开户行大额联行号（大额转账汇款使用）：308100005842 '},
        {text:'开户行大额交换号（走支票使用）：010821295 '},
      ],
       list1:[
        {text:'联系人：王蕾'},
        {text:'电话：17600987502 '},
        {text:'邮箱：wanglei@jiangtai.com'},
        
      ],
      cover:false,
      isActive:0,
      isActiveType: 0,
      dateActive: 0,
      typeActive:0,
      data:list,
      style:style,
      styleList:null,
      worryList:null,
      dataId:1,
      listId:1,
      detail:detail,
      detailList: null,
      personList:null,
      service:null,
      housekeeper:null,
      giftRights:null,
      serviceList:null,
      money:220,
      moneyId: 1,
      imagePath: require('./img/list/code.png'),
      payImg: '',
     
    }
  },
  beforeDestroy () {
    // 组件销毁之前,解除所有绑定
    this.$root.bus.$off('pid')
    this.$root.bus.$off('id')
  },
  created(){     
    this.init();
    
  },
  mounted(){
 if(this.dataId >= 5) {
        document.getElementById("ID").style.marginLeft ="-312px"
      }
  },
  methods:{
     closeclick() {
          this.cover = false
        },
    Button(type) {
     console.log(this.data.list)
      if(type == 'right') {
        document.getElementById("ID").style.marginLeft ="-312px"
         document.getElementById("ID").style.marginRight="0"
      }else {
        console.log(document.getElementById("ID").style.marginRight)
        if(document.getElementById("ID").style.marginLeft == '-312px') {
            document.getElementById("ID").style.marginLeft="0"
        }
      }
     console.log(type)
    },
    init () {
      let that = this
      console.log(this.$route.params.id)
      if (this.$route.params.pid) {
        this.dataId = this.$route.params.pid;
        this.isActive = this.$route.params.pid - 1;
        this.listId = this.$route.params.id;
        this.isActiveType = this.$route.params.id - 1;
        if (this.$route.params.pid == 1 && this.$route.params.id == 2) {
          this.money = 365
        }
      } else if (this.$route.params.id) {
        this.dataId = this.$route.params.id;
        this.isActive = this.$route.params.id - 1;
      } else {
        this.dataId = 1;
        this.isActive = 0;
      }
     
      console.log(this.isActive)
      this.dataIdForEach()
      this.listIdForEach()
      this.worryIdForEach()
      this.changeImgFun(this.dataId,this.listId)
      that.$root.bus.$on('id', value => {
        that.listId = value;
        that.isActiveType = value -1;
        that.changeImgFun(that.dataId, value)
        that.listIdForEach()
      })
      this.$root.bus.$on('pid', value => {
        console.log(value)
        if(value == 5 || value == 6 || value == 7) {
         document.getElementById("ID").style.marginLeft ="-312px"
         document.getElementById("ID").style.marginRight="0"
        }else {
         document.getElementById("ID").style.marginLeft="0"
        }
        that.dataId = value;
        if(value == '6') {
            that.isActive = '3'
        }else if(value == '7') {
          that.isActive = '4'
        }else{
               that.isActive = value - 1;
        }
    
        
        that.dataIdForEach()
        that.worryIdForEach()
        that.$refs.children.sonFun(value);
      })
      
      
    },
    dataIdForEach () {
      let that = this;
      this.style.list.forEach((item) =>{
        if (item.pid == that.dataId) {
          that.styleList = item
        }
      })
    },
    listIdForEach () {
      let that = this;
      this.detail.forEach((item) =>{
        if (item.pid == that.dataId) {
          item.list.forEach((list) =>{
            console.log(list.id,that.listId)
            if (list.id == that.listId) {
              that.detailList = list.detail
              that.personList = list.person
              that.service = list.equity.service
              that.housekeeper = list.equity.housekeeper
              that.giftRights = list.equity.giftRights
              that.serviceList = list.equity.serviceList
            } 
          })
        }
      })
    },
    worryIdForEach () {
      let that = this;
      this.style.worry.forEach((item) =>{
        if (item.pid == that.dataId) {
          that.worryList = item
        }
      })
    },
    choice (index,item) {
      console.log(index,item)
      console.log(item)
      if (item.id == 1) this.money = '220'
      this.dataId = item.id;
      this.listId = 1;
      this.isActiveType = 0;
      this.isActive = index;
      this.dataIdForEach()
      this.listIdForEach()
      this.worryIdForEach()
      this.changeImgFun(this.dataId,this.listId)
      this.$refs.children.sonFun(this.dataId);
    },
    choiceType (index,item) {
      this.listId = item.id;
      this.isActiveType = index;
      this.typeActive = 0
      if (this.dataId == 1 && this.listId == 1) {
        this.money = 220
        this.dateActive = 0
      } else if (this.dataId == 1 && this.listId == 2){
        this.money = 365
      }
      console.log(this.dataId)
      this.changeImgFun(this.dataId,this.listId)
      this.listIdForEach()
      
    },
    choiceTime (index,id) {
      this.dateActive = index
      if (this.moneyId == 1) {
        switch (id){
          case 1:
            this.money = '220'
          break;
          case 2:
            this.money = '69'
          break;
          case 3:
            this.money = '119'
          break;
                 
        }
      } else {
        switch (id){
          case 1:
            this.money = '59'
          break;
          case 2:
            this.money = '99'
          break;
          case 3:
            this.money = '139'
          break;
 
        }
      }   
    },
    choiceTypeMoney (index,item) {
      console.log(item)
      console.log(this.dataId)
      if(this.dataId == 7){
        if(item.id == 2) {
            this.cover = true
        }
      }
      this.typeActive = index
      // this.dateActive = 0
      console.log(this.detailList.time)
      this.moneyId = item.id
      if (this.detailList.time) {
        if (item.id == 1) {
          console.log(this.dateActive)
          switch (this.dateActive){
            case 0:
              this.money = '220'
            break;
            case 1:
              this.money = '69'
            break;
            case 2:
              this.money = '119'
            break;     
               
          }
        } else if(item.id == 2) {
          switch (this.dateActive){
            case 0:
              this.money = '59'
            break;
            case 1:
              this.money = '99'
            break;
            case 2:
              this.money = '139'
            break; 
              
          }
        }else if(item.id == 3) {
          console.log(3)
          this.detailList.money  = '594'
            this.money = '594'
        }else if(item.id == 4) {
          console.log(4)
           this.detailList.money  = '998'
            this.money = '998'
        }else if(item.id == 6) {
          console.log(3)
          this.detailList.money  = '5'
            this.money = '5'
        }else if(item.id == 7) {
          console.log(4)
           this.detailList.money  = '10'
            this.money = '10'
        }
      } else{
        if (item.id == 1) {
          this.money = '365'
        } else {
          this.money = '999'
        }
      }
    },
    todetail () {
      this.$router.push({
        name: 'rescuedetail',
        params:{
          pid:this.dataId,
          id:this.listId
        }
      })
    },
    changeImgFun(pid,sid){
      var id = ''
      if(pid == 1 && sid == 1){//短期个人
        id=19
      }else if(pid == 3 && sid == 1){//经典家庭
        id=9
      }else if(pid == 3 && sid == 2){//精英个人
        id=13
      }else if(pid == 2){//留学
        id=15
      }else if(pid == 4){//劳务
        id=17
      }else if(pid == 1 && sid == 2){//年度个人款
        id=31
      }else if(pid == 3 && sid == 3){//尊享家庭款
        id=35
      }
      this.payImg=util.config.urlApi + '/djxh5/#/introduceProduct?id=' + id +'&channelId=10' + '&productId=' + id
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './css/one.css';
  @import './css/two.css';
  em,i{
    font-style: normal;
  }
  .wrap *{
    color: #333;
  }
  .wrap{
    width: 100%;
    background: #fff;
  }
  .head{
    position: relative;
  }
  .head .banner{
    width: 100%;
  }
  .head .text{
    display: none;
    position: absolute;
    top: 6.8vw;
    width: 100%;
    text-align: center;
  }
  .head .text h2{
    font-size:5.2vw;
    color:rgba(255,255,255,1);
  }
  .head .text p{
    font-size:3vw;
    color:rgba(255,255,255,1);
    margin-top: 1.6vw;
  }
  .Bulletframe {
    padding: 10px 30px;
  }
  .textcals {
    background-color: #FBF4E4;
    color: #FC7802;
    padding: 10px;
    border-radius:10px;
    padding-left: 20px;
    margin-top: 10px;
  }
  .h3class {
    margin: 1.32vw 0vw 0vw 0vw !important;
  }
  .pclass {
   margin-bottom: 0.1vw !important;
  }
   .Popupclass {
    // height: 50%;
    // padding: 3vw;
    padding-bottom: 1vw;
    // background: red;
    position: fixed;
    top: -7vw;
    left: 3vw;
    right: 3vw;
    // bottom: 12vw;
    z-index: 9999;
  }
   .close {
      color: #666666;
      text-align: right;
      background: #00ABFA;
      padding: 30px 50px;
      line-height: 40px;
    }
  

  .Popupclass {
    width: 55%;
    z-index:9999;
    /* // height: 33%; */
    background-color: #FFFFFF;
    margin: 0 auto;
    margin-top: 12vw;
    // padding:2vw 3vw;
    box-sizing: border-box;
    padding-bottom: 20px;
    }
  
#cover {
    position: fixed;
    left: 0px;
    top: 0px;
    background: rgba(0, 0, 0, 0.5);
    width: 100%; /*宽度设置为100%，这样才能使隐藏背景层覆盖原页面*/
    height: 100%;
    filter: alpha(opacity=100); /*设置透明度为100%*/
    opacity: 1; /*非IE浏览器下设置透明度为100%*/
    display: block;
    z-Index: 999;
   }
  .dayclass {
    color: #0FABC0 !important;
  }
  .labclass {
    color: #9D8953 !important;
  }
  .labour {
    background-color: #E7C56C  !important;
  }
  .epidemic {
    background-color: #798EFB !important;
  }
  .Oneday {
     background-color: #20CBE2 !important;
  }
  .one{
    width: 100%;
  }
  .two{
    width: 100%;
    padding:2.5vw 0 0;
  }
  ul{
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    text-align: center;
    margin-top: 2vw;
        // overflow:hidden;
  text-overflow:ellipsis;
  }
  .worryGreen li h3,.highGreen,.twoGreen .service p,.twoGreen .serviceList p,.twoGreen .form .tr td,.twoGreen .form .tr td p,.twoGreen .introduce li p,.twoGreen .introduce li p span{
    color: rgba(3,178,123,1)!important;
  }
  
</style>



// WEBPACK FOOTER //
// src/views/rescuelist/rescuelist.vue